var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'map-button',
    _vm.type,
    {
      actived: _vm.actived
    }
  ],on:{"click":_vm.click}},[(_vm.title)?_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.type === 'icon')?_c('i',{staticClass:"map-button-icon",attrs:{"title":_vm.title}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e(),(!_vm.icon)?_vm._t("icon"):_vm._e()],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }